module.exports = __webpack_public_path__ + "img/AWS AppSync.71f24a87.png";